class FeaturedCollectionCarousel extends HTMLElement {
    constructor() {
      super();
       this.arrows = this.getAttribute("data-arrows")
       this.autoPlay = this.getAttribute("data-auto_play")
    }
  
    connectedCallback() {
  
     this.carousel = new theme.Slideshow(this, {
       prevNextButtons: this.arrows,
      // cellAlign: 'left',
      fullscreen: true,
      freeScroll: true,
      wrapAround: true,
      groupCells: 1,
      pageDots: false,
      contain: true,
      // autoPlay: !this.autoPlay ? 0 : 3000
      autoPlay: false,
      });
    }
  }
  customElements.define("featured-collection-carousel", FeaturedCollectionCarousel);
  
  window.dispatchEvent(new Event('resize'));
  